import React from 'react'
// import { getInitials } from '../../../utils/methods'
import { ImageUrl } from '../../../utils/constants'
import { HeaderPopup, ParticipantsHeader,/* ScrollWrapper, */StyledModal, StyledModalBody } from '../../HealthDataManagement/styles'
import { CloseIconBranding } from '../../../utils/icons'
import { ImageCard } from './styles'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { ButtonContainer, Button } from '../../common/CommonModal/style'
import { Border } from '../../Journeys/styles'
// import { ImageCard } from "../EngagementSectionV2/CompanyInitiative/styles";


function ViewInitiativeInfoPopup({showModal, onClose, onConfirm, initiativeDetails}) {


  return (
    <StyledModal
      isCenter={true}
      transform={1}
      show={showModal}
      newWidth={"400px"}
      newBg={"newBg"}
      height="268px"
      display="none"
      onHide={() => onClose()}
    >
      <HeaderPopup>
        <div className="title">Active Initiative</div>
        <div className="closeIcon" onClick={() => onClose()}>
          {CloseIconBranding()}
        </div>
      </HeaderPopup>

      <Border
        style={{
          width: "93%",
          background: "#EFEFEF",
          margin: "4px 16px 20px 16px",
        }}
      />

      {/* <div className="border-top"/> */}
      <StyledModalBody>
        <ParticipantsHeader  isWidth={"140px"}   style={{display:"flex", justifyContent:'center',alignItems:'center'}}>
          <ImageCard margin="auto 0 auto 8px" width bgColor={initiativeDetails?.color}>
            <img src={ImageUrl + "/" + initiativeDetails?.initiative_white_icon} />
          </ImageCard>
          <div className="initiative-wrap">
            <div className="initiative">{initiativeDetails?.initiative_name}</div>
            <div className="active-count">Active | +{initiativeDetails?.active_company_initiatives_count}pts</div>
          </div>
        </ParticipantsHeader>

        <div className="active-text">This initiative is currently active</div>
      </StyledModalBody>

      <Modal.Footer style={{borderTop:'none',display:'flex',paddingTop:'0px',paddingBottom:"16px",justifyContent:'center'}}>

        <ButtonContainer>
          { <Button
            isWidth="100px"
            isHeight="40px"
            background="transparent"
            color="#184A61"
            isFont={"16px"}
            backgroundHover="none"
            onClick={onClose}
          >
            Close
          </Button>}
          <Button
            isWidth={"165px"}
            isHeight="40px"
            isFont={"16px"}
            background="#DA6C74"
            color="white"
            onClick={onConfirm}
          >
            <div className="btn-text">View Initiative Info</div>
          </Button>
        </ButtonContainer>
        
      </Modal.Footer>
      
    </StyledModal>
  )
}



ViewInitiativeInfoPopup.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  initiativeDetails: PropTypes.object
};

export default ViewInitiativeInfoPopup
